// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.c-result-card[data-v-7445e03c] {\n  text-align: center;\n  width: 100%;\n}\n.c-actions[data-v-7445e03c] {\n  display: flex;\n  justify-content: center;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
